import React, { useEffect, useState } from "react";
function TeamMember({ member }) {
  const [image, setImage] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      const response = await import(`../../../assets${member.avatar}`);

      setImage(response.default);
    };
    fetchImage();
  }, [member]);
  return (
    <div className="checkbox-container">
      <img src={image} className="team-avater" alt="avatar" />
      <p className="label">{member?.name}</p>
    </div>
  );
}

export default TeamMember;
